module.exports=function(e){var t={};function r(o){if(t[o])return t[o].exports;var n=t[o]={i:o,l:!1,exports:{}};return e[o].call(n.exports,n,n.exports,r),n.l=!0,n.exports}return r.m=e,r.c=t,r.d=function(e,t,o){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(r.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var n in e)r.d(o,n,function(t){return e[t]}.bind(null,n));return o},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=43)}({1:function(e,t){e.exports=require("react")},2:function(e,t){e.exports=require("styled-components")},3:function(e,t){e.exports=require("../../styles")},43:function(e,t,r){"use strict";var o=this&&this.__createBinding||(Object.create?function(e,t,r,o){void 0===o&&(o=r),Object.defineProperty(e,o,{enumerable:!0,get:function(){return t[r]}})}:function(e,t,r,o){void 0===o&&(o=r),e[o]=t[r]}),n=this&&this.__setModuleDefault||(Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t}),a=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var r in e)"default"!==r&&Object.hasOwnProperty.call(e,r)&&o(t,e,r);return n(t,e),t},i=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const l=i(r(1)),d=a(r(2)),u=r(3),s=i(r(44)),{KineduPalette:c}=u.colorPalettes,f={primary:{main:c.cognitive,alt:"white"},secondary:{main:c.kinedu,alt:"white"},default:{main:c.shadeLighter,alt:c.shadeDark},disabled:{main:c.shadeMediumDark,alt:"white"},undefined:{main:"black",alt:"transparent"}},p=e=>{switch(e){case"primary":return f.primary;case"secondary":return f.secondary;case"default":return f.default;case"disabled":return f.disabled;default:return{main:e,alt:"white"}}},b=d.default.button`
  min-height: 50px;

  margin: 0;
  padding: 10px 20px;
  color: ${({color:e})=>p(e).main};
  background-color: transparent;
  border: none;
  border-radius: 4px;

  font-size: 14px;
  font-weight: bold;
  text-transform: unset;
  outline: none;

  cursor: pointer;

  position: relative;

  ${({fill:e})=>e?d.css`
    width: 100%;
  `:""}

  ${({small:e})=>e?d.css`
    min-height: 40px;
  `:""}

  ${({maxWidth:e})=>e&&("number"==typeof e?`max-width: ${e}px;`:`max-width: ${e};`)}

  ${({outline:e})=>e&&d.css`
    color: ${({color:e})=>p(e).main};
    background-color: transparent;
    border: ${({color:e})=>"1px solid "+p(e).main};
  `}

  ${({flat:e})=>e&&d.css`
    color: ${({color:e})=>p(e).alt};
    background-color: ${({color:e})=>p(e).main};
  `}

  ${({rounded:e})=>e&&d.css`
    border-radius: 100px;
  `}

  ${({disabled:e,flat:t,outline:r})=>e?t?d.css`
          color: ${f.disabled.alt};
          background-color: ${f.disabled.main};
          border: none;
          cursor: not-allowed;
        `:r?d.css`
          color: ${f.disabled.main};
          background-color: transparent;
          border: 1px solid ${f.disabled.main};
          cursor: not-allowed;
        `:d.css`
        color: ${f.disabled.main};
        background-color: transparent;
        cursor: not-allowed;
      `:""}

${({shadow:e})=>e&&d.css`
  box-shadow: 0px 4px 30px -12px ${c.shadeDark};
`}
`;t.default=({children:e,className:t,color:r,disabled:o,flat:n,onClick:a,outline:i,rounded:d,fill:u,small:c,shadow:f,maxWidth:p,style:m,loading:h,...x})=>l.default.createElement(b,Object.assign({type:"button","data-testid":"lego-styled-button",className:"lego-button "+t,color:r,disabled:o,flat:n,onClick:a,outline:i,rounded:d,maxWidth:p,fill:u?1:0,small:c?1:0,shadow:f,style:m},x),h?l.default.createElement(s.default,{loading:!0,name:"threedots",position:"relative",color:"white",bgColor:"transparent"}):e)},44:function(e,t){e.exports=require("../Spinner/Spinner")}});